import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { Router } from '@angular/router';
import { ADD_AGENDA_SOLUTION_FOLLOWER, AUTH_CODES_SEND, DELETE_AGENDA_SOLUTION_FOLLOWER, GET_AGENDA_SOLUTION_FOLLOWER } from 'manager/http-constants';
import {  } from 'protractor';
import { CommonService } from '../../../../shared/service/common.service';
import { DbOperationService } from '../../../../shared/service/db-operation.service';
import { LoadingState } from '../../../../shared/html-parts/loading/loading-state';
import { MessageData, ToastMessageData } from '../../../../shared/html-parts/message-common/message-data';
import { API_RESPONSE } from '../../../../shared/constant/api-constant';
import { TOAST } from '../../../../shared/constant/primeng-constants';
import { MESSAGE_CODE } from '../../../../shared/constant/message-constant';
import { LoginService } from '../../../../shared/service/login.service';

@Component({
  selector: 'app-follow-dialog',
  templateUrl: './follow-dialog.component.html',
  styleUrls: ['./follow-dialog.component.scss']
})
export class FollowDialogComponent implements OnInit {

  confirmFollowDialogFlag: boolean = false;
  confirmUnFollowDialogFlag: boolean = false;
  agendaID: string = '';
  agendaTitle:string = '';
  loginUser:any;
  listFollowed: any[]= [];
  member_id:string = '';
  @Output() returnValue = new EventEmitter<null>();

  constructor(
    public commonService: CommonService,
    public dbOperationService: DbOperationService,
    public loadingState: LoadingState,
    private messageData: MessageData,
    private router: Router,
    private loginService: LoginService,
  ) { }

  ngOnInit(): void {
  }

  /**
   * open follow dialog
   * @param agenda_id agenda to follow
   * @param agendaTitle agenda title to display
   * @param member_id created member id of given agenda
   */
  showConfirmFollowDialog(agenda_id:string,agendaTitle:string,member_id:string){
    this.loginUser = JSON.parse(sessionStorage.getItem('loginUserInformation'));
    this.agendaID = agenda_id;
    this.agendaTitle = agendaTitle;
    this.member_id = member_id;
    this.confirmFollowDialogFlag = true;
    if(this.loginUser){
      this.getListFollow(agenda_id);
    }
  }

  /**
   * open unfollow dialog
   * @param agenda_id agenda to unfollow
   * @param agendaTitle agenda title to display
   */
  showConfirmUnFollowDialog(agenda_id:string,agendaTitle:string){
    this.loginUser = JSON.parse(sessionStorage.getItem('loginUserInformation'));
    this.agendaTitle = agendaTitle;
    this.agendaID = agenda_id;
    this.confirmUnFollowDialogFlag = true;
    this.getListFollow(agenda_id);
  }

  /**
   * run process following agenda
   */
  confirmFollow(){
    this.loadingState.loadStart(ADD_AGENDA_SOLUTION_FOLLOWER);

    this.dbOperationService.insertData(ADD_AGENDA_SOLUTION_FOLLOWER, {
      agenda_id: this.agendaID,
      member_id: this.loginUser.member_id,
    }).subscribe((response) => {
      this.loadingState.loadSleepEnd(0.3, ADD_AGENDA_SOLUTION_FOLLOWER);

      if (API_RESPONSE.SUCCESS == response.body.Message) {
        this.messageData.toastMessage(
          new ToastMessageData({
            severity: TOAST.SUCCESS,
            summary: this.commonService.msg(MESSAGE_CODE.T00001),
            detail: this.commonService.msg(MESSAGE_CODE.I00020),
          })
        );
        this.router.navigate(['pages/platform/c104/']);
        this.closeDialog();
      } else {
      this.loadingState.loadSleepEnd(0.3, ADD_AGENDA_SOLUTION_FOLLOWER);
        this.messageData.toastMessage(
          new ToastMessageData({
            severity: TOAST.ERROR,
            summary: this.commonService.msg(MESSAGE_CODE.E00034),
            detail: this.commonService.msg(MESSAGE_CODE.E00035),
          })
        );
      }
    });
  }

  /**
   * run process unfollowing agenda
   */
  confirmUnFollow(){
    this.loadingState.loadStart(DELETE_AGENDA_SOLUTION_FOLLOWER);

    this.dbOperationService.deleteDataMultipleArg(DELETE_AGENDA_SOLUTION_FOLLOWER,
      this.loginUser.member_id, this.agendaID
    ).subscribe((response) => {
      this.loadingState.loadSleepEnd(0.3, DELETE_AGENDA_SOLUTION_FOLLOWER);

      if (API_RESPONSE.SUCCESS == response.body.Message) {
        this.messageData.toastMessage(
          new ToastMessageData({
            severity: TOAST.SUCCESS,
            summary: this.commonService.msg(MESSAGE_CODE.T00001),
            detail: this.commonService.msg(MESSAGE_CODE.I00021),
          })
        );
        this.returnValue.emit();
        this.closeDialog();
      } else {
      this.loadingState.loadSleepEnd(0.3, DELETE_AGENDA_SOLUTION_FOLLOWER);
        this.messageData.toastMessage(
          new ToastMessageData({
            severity: TOAST.ERROR,
            summary: this.commonService.msg(MESSAGE_CODE.E00034),
            detail: this.commonService.msg(MESSAGE_CODE.E00035),
          })
        );
      }
    });
  }

  /**
   * close dialog
   */
  closeDialog(){
    this.confirmFollowDialogFlag = false;
    this.confirmUnFollowDialogFlag = false;
  }

  /**
  * get list agenda followers
  * @param agendaId agenda to get data
  */
  getListFollow(agendaId:string){
    this.listFollowed = [];
    this.loadingState.loadStart();

    // 課題・ソリューション詳細を取得
    this.dbOperationService
      .getNoTemplateDisplayData(GET_AGENDA_SOLUTION_FOLLOWER, agendaId)
      .subscribe((response) => {
        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3, GET_AGENDA_SOLUTION_FOLLOWER);

        if (this.commonService.checkNoneResponse(response)) {
          if (response.body?.length<=0) {
            // 警告メッセージ
            this.messageData.toastMessage(
              new ToastMessageData({
                severity: TOAST.WARN,
                summary: this.commonService.msg(MESSAGE_CODE.E00003),
                detail: this.commonService.msg(MESSAGE_CODE.E00026),
              })
            );
          }
          this.listFollowed = [];
          this.loadingState.loadEnd();
        } else {
          this.listFollowed = response.body;
          this.loadingState.loadEnd();
        }
      });
  }

  /**
   * 会員プロフィール(B211 or B212)へ遷移する
   * @param memberId 会員ID
   * @param classId 会員種別
   */
  public moveB211orMoveB212(memberId: string, classId: string): void {
    if(this.loginUser ){
      // 自治体 or 2号会員が否か
      if ('1' == classId || '2' == classId) {
        // 自治体 or 2号会員の場合

        // 会員プロフィール(自治体)(B211)へ遷移
        this.router.navigate(['pages/platform/b211/' + memberId]);
      } else {
        // 民間団体の場合

        // 会員プロフィール(民間団体)(B212)へ遷移
        this.router.navigate(['pages/platform/b212/' + memberId]);
      }
    }
  }

  loginToC104(){
    this.loginService.loginToPage('/redirect?agendaID='+this.agendaID+'&memberID='+this.member_id+'&mode=0');
  }

  /**
  * move to a201
  */
  public moveA201(): void {
    // 入会申請(A201)へ遷移
    this.router.navigate(
      ['pages/platform/a201/new'],
      {
        queryParams: { screenId: 'a201' },
      }
    );
  }
}
